import { useState } from "react";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

const RoundNumber = () => {
  const [number, setNumber] = useState(null);
  const [nodeci, setNodeci] = useState(null);
  const [nodeciValue, setNodeciValue] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [errors, setErrors] = useState({});

  const [copy, setCopy] = useState(false);

  const handleOnClick = () => {
    if (validateForm()) {
      let x = number * nodeci;
      let y = Math.round(x);
      let z = y / nodeci;
      setAnswer(z);
      setCopy(false);
    }
  };

  const handleOnChange = (e) => {
    setAnswer("");
    setNumber(e.target.value);
    setCopy(false);
    setErrors({ ...errors, [e.target.name]: "" });
  };
  const handleOnChangesec = (e) => {
    setAnswer("");
    setNodeciValue(e.target.value);
    setNodeci(Math.pow(10, e.target.value));
    setCopy(false);
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let formIsValid = true;
    let err = {};

    if (!number) {
      err.value = "* Please enter number";
      formIsValid = false;
    }
    if (!nodeciValue) {
      err.number = "* Please enter number";
      formIsValid = false;
    }

    setErrors(err);
    return formIsValid;
  };

  return (
    <>
      <div className="commom-box-new">
        <div className="input-new">
          <label>Enter a value here.</label>

          <input
            type="number"
            name="value"
            placeholder="Ex. 121.315"
            value={number}
            className={errors?.value && "error-input"}
            onChange={(e) => {
              e.target.value >= 0 && handleOnChange(e);
            }}
          ></input>
          <span className="text-sm text-red-700">{errors?.value}</span>
        </div>
      </div>
      <div className="commom-box-new aritmetic-top-alignment">
        <div>
          <div>
            <div className="input-new">
              <label>Enter round precision here.</label>
              <input
                type="number"
                className={errors?.number && "error-input"}
                name="number"
                onChange={(e) => {
                  e.target.value >= 0 && handleOnChangesec(e);
                }}
              />
              <span className="text-sm text-red-700">{errors?.number}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="button arithmetic-button-center-alignment-new-one">
        <button onClick={handleOnClick}>Generate Now</button>
      </div>
      {answer && (
        <div className="commom-box-new">
          <div className="copy-icon-new">
            <FiCopy onClick={() => handleCopy(answer)} />
            {copy && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="input-new" style={{ position: "relative" }}>
            <input value={answer} className="text-black" />
          </div>
        </div>
      )}
    </>
  );
};

export default RoundNumber;
